module.exports = __webpack_public_path__ + "static/media/huodong.ac38dd89.png";